// extracted by mini-css-extract-plugin
var _1 = "EmployeesGroup_avatar__39e51";
var _2 = "EmployeesGroup_avatarBorder__00ba7";
var _3 = "EmployeesGroup_base__ff4b5";
var _4 = "EmployeesGroup_editorHeader__9afbe";
var _5 = "EmployeesGroup_large__04675";
var _6 = "EmployeesGroup_medium__00f7c";
var _7 = "EmployeesGroup_mentionOverflow__403e6";
var _8 = "EmployeesGroup_mentioned__4d300";
var _9 = "EmployeesGroup_mini__76f00";
var _a = "EmployeesGroup_overflow__b181d";
var _b = "EmployeesGroup_overflowList__dffbb";
var _c = "EmployeesGroup_overflowShifted__a7689";
var _d = "EmployeesGroup_overlayContainer__7d1ff";
var _e = "EmployeesGroup_overlayShifted__213b1";
var _f = "EmployeesGroup_shifted__55095";
export { _1 as "avatar", _2 as "avatarBorder", _3 as "base", _4 as "editorHeader", _5 as "large", _6 as "medium", _7 as "mentionOverflow", _8 as "mentioned", _9 as "mini", _a as "overflow", _b as "overflowList", _c as "overflowShifted", _d as "overlayContainer", _e as "overlayShifted", _f as "shifted" }
